import gsap from 'gsap';

import Swiper from 'swiper';

export default () => {
  //greeting(); //Animation char by char in the home
  setTimeout(function(){
    posterSlider();
  }, 1000);
  

  function greeting() {
    let greeting = document.querySelector('.greeting');
    if (greeting) {
      let title = document.querySelector('.greeting__title');
      if (title) {
        split(title);
      }

      let elements = greeting.querySelectorAll('span, .greeting__text');
      title.style.visibility = 'visible';
      gsap.fromTo(elements,
        {
          opacity: 0,
          y: 100
        },
        {
          opacity: 1,
          y: 0,
          duration: 1.8,
          ease: 'power3.out',
          stagger: 0.1,
        }
      )
    }
  }

  function posterSlider() {
    let slider = document.querySelector('.h-poster__slider');
    if (slider) {
      let mainSlider = new Swiper(slider, {
        wrapperClass: "h-poster__slider-wrapper",
        slideClass: "h-poster__slide",
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 600,
        touchStartPreventDefault: false,
      });
    }
  }

  function split(el) {
    let text = el.textContent.split("");
    let result = "";
    text.forEach(function(char){
      result += (char.trim() === "") ? "" : "<span class='greeting__symbol'>" + char + "</span>";
    });
    el.innerHTML = result;
  }
}
